module.exports = __webpack_public_path__ + "static/media/ilustracion-komunidad-message.976c822d.png";